module.exports = __webpack_public_path__ + "static/img/logo10@2x.55a697f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo10@2x.jpg
// module id = DkID
// module chunks = 1